'use client';

import { useTranslations } from 'next-intl';
import { DieselRingSelectionContextProvider } from 'components/uh-x-diesel/buy/DieselRingSelectionContext';
import {
  PageContent,
  ProductSelectionSection,
} from 'components/uh-x-diesel/buy';

import { Currency } from 'utils/Currency';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import {
  DieselRingColors,
  DieselRingSizes,
  getDieselRingBuyPageFaqData,
} from 'content/products/dieselRing';
import { useGlobalUI } from 'contexts/GlobalUIContext';
import { useTripleWhaleProductView } from 'hooks/analytics/useTripleWhaleProductView';

type DieselBuyPageProps = {
  region: string;
  defaultSize: DieselRingSizes | null;
  defaultColor: DieselRingColors | null;
  defaultUhx: boolean;
  store: ShopifyStore;
  currency: Currency;
};

export default function DieselBuy({
  region,
  defaultSize,
  defaultColor,
  defaultUhx,
  store,
  currency,
}: DieselBuyPageProps) {
  useGlobalUI({ headerCollaspable: false });
  useTripleWhaleProductView('diesel', store);
  const t = useTranslations('dieselRing');
  const tRing = useTranslations('ring');

  const regionUpper = region.toUpperCase();
  const isUS = regionUpper === 'US' || regionUpper === 'PR';

  return (
    <>
      <DieselRingSelectionContextProvider
        currency={currency}
        defaultSize={defaultSize}
        defaultColor={defaultColor ?? DieselRingColors.CRYO}
        defaultUhx={defaultUhx}
        {...(isUS
          ? {
              notServicable: true,
              notServicableMessage: tRing(
                'ring.buyPage.notServicableMessage',
              ),
            }
          : {})}
      >
        <ProductSelectionSection
          description={tRing('ring.buyPage.productDescription')}
        />
        <PageContent
          faqData={getDieselRingBuyPageFaqData(t, tRing)}
          wizardTitle={t('buy.productWizard')}
        />
      </DieselRingSelectionContextProvider>
    </>
  );
}
